export const stageGoals = {
  invitation: [
    "I have described the conflict in neutral terms.",
    "I have talked about what I've already tried to resolve the conflict.",
    "I have talked about how I feel about the conflict",
    "I have thought about the other side's perspective",
    "I have determined what's important to me in resolving the conflict.",
  ],
  connection: [
    "I have a plan to express my intent to be collaborative and stay friendly",
    "I have a way to describe the conflict situation to the other person that does not blame them for it.",
    "I can tell the other that I am open to hearing their perspective and creating a good outcome together.",
    "I can think of a way to open the conversation with them: where, when and how.",
  ],
  exchange: [
    "I know the hopes, goals and values I want the other person to hear about how I see the conflict.",
    "I AM open to hearing the hopes, goals and values that the other person will want me to hear.",
    "I have some good open questions to ask them about their perspective.",
    "I feel that I can balance what I hear and what I share throughout the conversation.",
  ],
  agreement: [
    "I have some ideas about how to amend what has happened in the past that will work for both/all of us.",
    "I can invite new ideas or changes to improve interactions in the future?",
    "I have a way to check in to see whether ideas work for both/all parties.",
    "I can make decisions and commitments about the who, what, when, and how aspects of the agreement.",
  ],
  reflection: [
    "I have thought about how well I handled the relationship part of the conflict conversation.",
    "I have thought about how satisfied I am with the outcomes or agreements made in this conversation.",
    "I plan to use a summary statement to wrap up the conversation on a positive note; send an email or make a call to confirm the agreements and follow up on specific items."
  ], 
}

export const stageDescriptions = {
  invitation: `The goal of this stage is to attain a productive mindset and framing of the conflict.
  Describe the conflict objectively and look at it from various perspectives; Focus on your and the
  other party's awareness, readiness, and understanding of the conflict; Eventually strategize how
  to set up an environment for a collaborative conversation with the other person in your conflict.`,

  connection:  `In the Connection stage, think about how to invite the other person into a
  productive conversation; start with the other person's state of mind, heart and then share yours;
  Clarify together what needs to be addressed and resolved in the conversation.`,

  exchange: `In the Exchange stage, the goal is to delve into the conversation with the other
  party. How can you exchange relevant information and build shared meaning about what is
  important about the conflict (and why it is important); Look for common ground, and explore
  what is important in terms of each other's perspective.`,

  agreement: `In the Agreement stage, aim to co-create possible solutions with the other party;
  More specifically, explore potential options based on what is important to both parties; and then
  evaluate their options and check for fairness to ensure that the needs of both sides are met.
  Lastly, form an action plan: who, what, when, where, how, and work out the details.`,

  reflection: `In the final Reflection stage, discuss with the chatbot how satisfied both parties
  about the outcomes; Try to establish follow-up steps and future check-ins. Establish what you
  have learned about this conflict that you can apply to future conflicts.`
}

export const stageCaps = {
  invitation: 6,
  connection: 8,
  exchange: 12,
  agreement: 10,
  reflection: 6
}